import {
  MermaidRenderExtension,
  type MermaidRenderOutput,
} from '@blocksuite/affine-shared/services';

import {
  MermaidCanvasRenderRuntime,
  resolveMermaidCanvasTheme,
} from '../../../modules/code-block-preview-renderer';

export const affineMermaidRenderExtension = MermaidRenderExtension({
  createSession() {
    const runtime = new MermaidCanvasRenderRuntime();

    return {
      dispose() {
        runtime.dispose();
      },
      async render(input): Promise<MermaidRenderOutput> {
        const result = await runtime.render({
          source: input.source,
          theme: resolveMermaidCanvasTheme(input.themeMode, input.prefersDark),
          visible: input.visible,
          zoom: input.zoom,
        });

        switch (result.status) {
          case 'ready':
          case 'degraded':
            return {
              status: result.status,
              svg: result.svg,
              intrinsicSize: result.intrinsicSize,
            };
          case 'invalid':
          case 'error':
            return {
              status: result.status,
              message: result.issue.message,
              svg: result.lastValid?.svg,
              intrinsicSize: result.lastValid?.intrinsicSize,
            };
          default:
            return { status: result.status };
        }
      },
    };
  },
});
